import { render, staticRenderFns } from "./VideoSettingTab.vue?vue&type=template&id=7eadcad7&scoped=true&"
import script from "./VideoSettingTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoSettingTab.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoSettingTab.vue?vue&type=style&index=0&id=7eadcad7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eadcad7",
  null
  
)

export default component.exports